import api from './api'

const userCompanyBasePath = '/api/v1/user-company'

export async function getUserCompanies({ params }) {
  const resp = await api.get(`${userCompanyBasePath}`, { params })
  return resp.data
}

export async function getUserCompany({ userCompanyId, params }) {
  const resp = await api.get(`${userCompanyBasePath}/${userCompanyId}`, { params })
  return resp.data
}

export async function createUserCompany({ params, ...createUserCompanyData }) {
  const resp = await api.post(`${userCompanyBasePath}`, createUserCompanyData, { params })
  return resp.data
}

export async function patchUserCompany({ userCompanyId, params, ...userCompanyUpdates }) {
  const resp = await api.patch(`${userCompanyBasePath}/${userCompanyId}`, userCompanyUpdates, { params })
  return resp.data
}

export async function deleteUserCompany({ userCompanyId, params }) {
  const resp = await api.delete(`${userCompanyBasePath}/${userCompanyId}`, { params })
  return resp.data
}
